import React from "react";
import { OneRow } from "../../core/layouts";
import AuditListingContainer from "../../containers/AuditListingContainer";

const AuditListingView = () => {
  return <OneRow section={<AuditListingContainer />} />;
};

export default AuditListingView;
